import * as React from "react";
import { useEffect, useRef, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { Tooltip } from "primereact/tooltip";
import Button from "react-bootstrap/Button";
import { Controller, useForm } from "react-hook-form";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { useDispatch, useSelector } from "react-redux";
import { getBank } from "../../StateManagement/BankSlice";
import { getProvince } from "../../StateManagement/ProvinceSlice";
import { logoutStatic } from "../../StateManagement/authSlice";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { InputFormat } from "../../Landing/Components/FormOptions/InputFormat";
import TelInput from "../../Landing/Components/FormOptions/TelInput";
import { DropDownFormat } from "../../Landing/Components/FormOptions/DropDownFormat";
import DataTableTemplate from "../Components/DataTableTemplate";
import { PanelContainer } from "../Components/PanelContainer";
import { fetchData, formatNumber } from "../Components/Utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Row } from "react-bootstrap";

export const DisableUsers = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const editComponentRef = useRef(null);
  const dispatch = useDispatch();
  const bank = useSelector((state) => state?.bank?.bank);
  const province = useSelector((state) => state?.province?.province);
  const navigate = useNavigate();
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [educationList, setEducationLis] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [defaultRows, setDefaultRows] = useState(20);
  const [showEditComponent, setShowEditComponent] = useState(false);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });
  const [banksList, setbanksList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [ProvinceList, setProvinceList] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);

  const defaultValues = {
    mobrt: "",
    ACCno: "",
    Address: "",
    BirthDay: new Date(),
    Born: "",
    CartNo: "",
    CityId: "",
    Email: "",
    FatherName: "",
    IdOfReAgent: "",
    InsPay: 0,
    Job: "",
    PassWord: "",
    PostalCode: "",
    ProvinceId: "",
    Sheba: "",
    Tel: "",
    addTitle: "",
    coin: "",
    edu: "",
    family: "",
    grade: "",
    idcode: "",
    idofbank: "",
    latlong: "",
    name: "",
    pic: "",
    sex: "",
    shsh: "",
    Mob: "",
    referral: "",
    uid: "",
    regdate: "",
    no: "",
    unit: "",
    groupid: "",
  };
  const {
    watch,
    handleSubmit,
    control,
    register,
    setValue,
    reset,
    formState: { errors },
  } = useForm({ defaultValues });

  const dt = useRef(null);
  const cols = [
    {
      field: "Mob",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "Mob",
      header: "نام و نام خانوادگی",
      body: (data, options) => data?.Name + " " + data?.Family,
    },
    {
      field: "Mob",
      header: "جنسیت",
      body: (data) => sexTemplate(data),
    },
    {
      field: "Mob",
      header: "شماره موبایل",
    },
    { field: "RegDate", header: "تاریخ عضویت" },
    { field: "coin", header: " آخرین ورود" },
    { field: "sex", header: "جنسیت" },
    { field: "ProvinceName", header: "استان" },
    { field: "CityName", header: "شهر" },
    {
      field: "CityName",
      header: "تعداد سکه",
      body: (data) => (
        <div style={{ direction: "ltr", textAlign: "center" }}>
          <a
            className="text-decoration-underline "
            onClick={() => navigate(`/cpanel/users/${data?.uid}`)}
          >
            {formatNumber(data?.coin)}
          </a>
        </div>
      ),
    },
    {
      field: "CityName",
      header: "تعداد زیرمجموعه مستقیم",
      body: (data) => (
        <a
          className="text-decoration-underline"
          onClick={() => navigate(`/cpanel/users/detail/${data?.uid}`)}
        >
          {data?.referral}
        </a>
      ),
    },
    {
      field: "CityName",
      header: "عملیات",
      body: (data, options) => (
        <div className="my-1">
          <FontAwesomeIcon
            icon={"edit"}
            onClick={() => handleOpeEditItem(data)}
            className="icon-sm prime-bg text-white p-1 text-center rounded"
            color="gray"
          />
          <div className="d-flex  gap-1 "></div>
        </div>
      ),
    },
  ];
  console.log(selectedCustomers);
  const fetchEduList = async () => {
    try {
      const responseGlobal = await axios.post(
        BASE_URL,
        {},
        {
          headers: {
            "Content-Type": "multipart/form-date",
            cmd: "edu",
          },
        }
      );
      if (responseGlobal.status === 200) {
        const data = responseGlobal.data?.dt;
        const formattedOptions = mapOptions(data);
        setEducationLis(formattedOptions);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      throw new Error("Cpanel users edu  Error: ", error.message);
    }
  };
  const fetchGroupList = async () => {
    try {
      const responseGlobal = await axios.post(
        BASE_URL,
        {},
        {
          headers: {
            "Content-Type": "multipart/form-date",
            cmd: "grouplist",
          },
        }
      );
      if (responseGlobal.status === 200) {
        const data = responseGlobal.data?.dt;
        const mapCats = (apiResponse) => {
          return apiResponse?.map((item) => ({
            value: item.id.toString(),
            label: item.groupname,
          }));
        };
        const formattedOptions = mapCats(data);
        setGroupList(formattedOptions);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      throw new Error("Cpanel users cat list Error: ", error.message);
    }
  };
  //   const fetchdata = async (e) => {
  //     const bodyFormData = new FormData();
  //     bodyFormData.append("guid", Cookies.get("guid"));
  //     bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
  //     bodyFormData.append("pageSize", lazyState?.rows ?? 20);
  //     try {
  //       const response = await axios.post(BASE_URL, bodyFormData, {
  //         headers: {
  //           "Content-type": "multipart/form-date",
  //           Accept: "application/json",
  //           cmd: "userlist",
  //         },
  //       });
  //       if (response.status === 200) {
  //         const data = await response;
  //         setUserList(data?.data?.dt);
  //         setTotalRecords(data?.data?.count);
  //         fetchEduList();
  //         fetchGroupList();
  //       } else {
  //         console.error(`API request failed with status: ${response.status}`);
  //       }
  //     } catch (error) {
  //       console.error("Error while fetching menu data:", error);
  //     }
  //   };

  const onpage = (event) => {
    setLazyState({
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
    setDefaultRows(event.rows);
  };
  useEffect(() => {
    // fetchdata();

    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    fetchData("userlist", bodyFormData, handleApiResponse);
  }, [lazyState]);

  const handleApiResponse = (data) => {
    setUserList(data?.dt);
    setTotalRecords(data?.count);
    fetchEduList();
    fetchGroupList();
  };
  const fetchUserData = async (id, rowData) => {
    const bodyFormData = new FormData();
    bodyFormData.append("uid", id);

    try {
      const response = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          "Content-type": "multipart/form-date",
          Accept: "application/json",
          cmd: "guid",
        },
      });
      if (response.status === 200) {
        const data = await response;
        const userData = data?.data?.userinfo;
        reset({
          ...defaultValues,
          ...userData,
          Mob: rowData.Mob,
          referral: rowData.referral,
          uid: rowData.uid,
          Address: userData?.Address?.split("|")[0],
          no: userData?.Address?.split("|")[1],
          unit: userData?.Address?.split("|")[2],
          BirthDay: new Date(userData?.BirthDay) || new Date(),
        });
      } else {
        console.error(`API request failed with status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      const bodyFormData = new FormData();
      bodyFormData.append("provinceId", watch("ProvinceId"));
      try {
        const response = await axios.post(BASE_URL, bodyFormData, {
          headers: {
            "Content-type": "multipart/form-data",
            Accept: "application/json",
            cmd: "city",
          },
        });
        if (response.status === 200) {
          const data = await response.data;

          return data?.dt;
        } else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      } catch (error) {
        throw error;
      }
    };
    if (!watch("ProvinceId")) {
      setCityList([]);
      return;
    }
    fetchData().then((value) => {
      const mapOptions = (apiResponse) => {
        return apiResponse?.map((item) => ({
          value: item.cityid,
          label: item.cityname,
        }));
      };
      const data = mapOptions(value);
      setCityList(data);
    });
  }, [watch("ProvinceId")]);

  const handleOpeEditItem = (data) => {
    if (data) {
      fetchUserData(data?.uid, data);
      setSelectedUserId(data?.uid);
      setIsEditMode(true);
    } else {
      reset(defaultValues);
      setIsEditMode(false);
    }
    setShowEditComponent(false);
    setTimeout(() => {
      setShowEditComponent(true);
    }, 0);
    dispatch(getBank());
    const mapOptions = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.BankId.toString(),
        label: item.BankTitle,
      }));
    };
    const datas = mapOptions(bank);
    setbanksList(datas);
    dispatch(getProvince());
    const proviceOptions = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.provinceid,
        label: item.provincename,
      }));
    };
    const provinceData = proviceOptions(province);
    setProvinceList(provinceData);
  };

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  // const exportCSV = (selectionOnly) => {
  //     dt.current.exportCSV({selectionOnly});
  // };
  //
  // const exportPdf = () => {
  //     import('jspdf').then((jsPDF) => {
  //         import('jspdf-autotable').then(() => {
  //             const doc = new jsPDF.default(0, 0);
  //
  //             doc.autoTable(exportColumns, userList);
  //             doc.save('products.pdf');
  //         });
  //     });
  // };
  const handleOpenDisableUsers = () => {
    navigate("/cpanel/disableusers");
  };
  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const excelList = userList.map((item) => ({
        "شناسه کاربر": item.uid,
        نام: item.Name,
        "نام خانوادگی": item.Family,
        "شماره موبایل": item.Mob,
        "تاریخ عضویت": item.RegDate,
        گروه: item.groupid,
        "تعداد زیر مجموعه": item.referral,
      }));
      const worksheet = xlsx.utils.json_to_sheet(excelList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "products");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };
  const header = (
    <div className="d-flex align-items-center justify-content-between">
      <FontAwesomeIcon
        icon={"file-excel"}
        size={40}
        onClick={exportExcel}
        className=" p-2 rounded btn btn-info  cursor-pointer"
      />
      <Button
        type={"button"}
        className="text-center  p-2 "
        onClick={() => navigate("/cpanel/supportList")}
      >
        لیست حمایت ها
      </Button>
    </div>
  );
  const mapOptions = (apiResponse) => {
    return apiResponse?.map((item) => ({
      value: item.EduId.toString(),
      label: item.EduTitle,
    }));
  };

  const onSubmit = async (data) => {
    const bodyFormData = new FormData();
    bodyFormData.append("name", data?.name);
    bodyFormData.append("family", data?.family);
    bodyFormData.append("sex", data?.sex);
    bodyFormData.append("BirthDay", new Date(data?.BirthDay));
    bodyFormData.append("Mob", data?.Mob);
    bodyFormData.append("idcode", data?.idcode);
    bodyFormData.append("shsh", data?.shsh);
    bodyFormData.append("Born", data?.Born);
    bodyFormData.append("FatherName", data?.FatherName);
    bodyFormData.append("edu", data?.edu);
    bodyFormData.append("Job", data?.Job);
    bodyFormData.append("Email", data?.Email);
    bodyFormData.append("PassWord", data?.PassWord);
    bodyFormData.append("bankid", data?.idofbank);
    bodyFormData.append("accno", data?.ACCno);
    bodyFormData.append("cartno", data?.CartNo);
    bodyFormData.append("sheba", data?.Sheba);
    bodyFormData.append("provinceId", data?.ProvinceId);
    bodyFormData.append("cityId", data?.CityId);
    bodyFormData.append("postalcode", data?.PostalCode);
    bodyFormData.append(
      "address",
      data?.Address + "|" + data?.no + "|" + data?.unit
    );
    bodyFormData.append("groupid", data?.groupid ?? 0);

    let cmd = "createuser";
    if (selectedUserId) {
      bodyFormData.append("uid", selectedUserId);
      bodyFormData.append("mobrt", data?.mobrt);
      cmd = "updateuser";
    }
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: cmd,
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
          dispatch(logoutStatic());
          navigate("/");
        }
        SweetAlert({
          title: "",
          text: selectedUserId
            ? "اطلاعات با موفقیت به روز رسانی شد"
            : "کاربر جدید اضافه شد.",
          type: "success",
        });
        fetchData("userlist", bodyFormData, handleApiResponse);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  useEffect(() => {
    // Scroll to the edit component when it becomes visible

    if (showEditComponent && editComponentRef.current) {
      console.log(showEditComponent);
      editComponentRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [showEditComponent]);
  const sexTemplate = (rowData) => {
    return rowData.sex === 1 ? "مرد" : "زن";
  };
  return (
    <PanelContainer title={"کاربران غیرفعال"}>
      <Tooltip target=".export-buttons>button" position="bottom" key="" />
      <DataTableTemplate
        lazyState={lazyState}
        // select='select'
        className={"table-border"}
        columns={cols}
        list={userList}
        totalRecords={totalRecords}
        setlazyState={setLazyState}
        setDefaultDatatableRows={setDefaultDatatableRows}
        defaultDatatableRows={defaultDatatableRows}
        width="25rem"
      />
      {showEditComponent && (
        <div ref={editComponentRef} className="edit row m-5 ">
          <div className="panel-heading prime-bg text-white text-center py-2 m-2">
            <span id="ContentPlaceHolder1_lblbannerheading ">
              {isEditMode ? "ویرایش کاربر" : "ایجاد کاربر جدید"}
            </span>
          </div>
          <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
            <Row className="d-flex align-items-center">
              <Col className=" col-6 col-lg-6">
                <DropDownFormat
                  control={control}
                  label={"گروه"}
                  options={groupList}
                  errors={errors}
                  name={"groupid"}
                />
              </Col>
              <Col className="col-6">
                <Button
                  className="text-center mt-4 p-2 mb-2"
                  onClick={() => navigate("/cpanel/category")}
                >
                  افزودن گروه بندی جدید
                </Button>
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6">
                <TelInput
                  control={control}
                  name="mobrt"
                  type={"tel"}
                  defaultValue={""}
                  label="شماره موبایل معرف"
                  errors={errors}
                />
              </Col>
              <Col className=" col-12 col-lg-6">
                <TelInput
                  control={control}
                  name="Mob"
                  type={"tel"}
                  defaultValue={""}
                  label="شماره موبایل"
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="name"
                  type={"text"}
                  label="نام"
                  errors={errors}
                />
              </Col>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="family"
                  type={"text"}
                  label="نام خانوادگی"
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6">
                <Form.Group className="mb-3 w-75" controlId="formBasicSex">
                  <Form.Label className="fw-bold pb-1">جنسیت </Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    {...register("sex", {
                      required: "جنسیت الزامی است",
                    })}
                  >
                    <option value="" disabled>
                      انتخاب کنید...
                    </option>
                    <option value="1">مرد</option>
                    <option value="2">زن</option>
                  </Form.Select>
                  {errors.sex && (
                    <div className="text-danger">{errors.sex.message}</div>
                  )}
                </Form.Group>
              </Col>
              <Col className=" col-12 col-lg-6">
                <Form.Group className="mb-3 w-75 ">
                  <Form.Label className="fw-bold pb-1">تاریخ تولد</Form.Label>
                  <Controller
                    control={control}
                    name="BirthDay"
                    rules={{ required: true }} //optional
                    render={({ field }) => (
                      <>
                        <DatePicker
                          className="txt-center"
                          {...field}
                          format={"YYYY-MM-DD"}
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-right"
                          defaultValue={"1996-12-02T12:01:39.860Z"}
                        />
                        {errors.BirhDay && <span>تاریخ تولد الزامی است</span>}
                      </>
                    )}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6">
                <TelInput
                  control={control}
                  name="idcode"
                  type={"tel"}
                  defaultValue={""}
                  label="کدملی"
                  errors={errors}
                />
              </Col>{" "}
              <Col className=" col-12 col-lg-6">
                <TelInput
                  control={control}
                  name="shsh"
                  type={"tel"}
                  defaultValue={""}
                  label="شماره شناسنامه"
                  errors={errors}
                />
              </Col>
            </Row>{" "}
            <Row>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="FatherName"
                  type={"text"}
                  label="نام پدر"
                  errors={errors}
                />
              </Col>{" "}
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="Born"
                  type={"text"}
                  label="محل تولد"
                  errors={errors}
                />
              </Col>
            </Row>{" "}
            <Row>
              <Col className=" col-12 col-lg-6">
                <DropDownFormat
                  control={control}
                  label={"تحصیلات"}
                  options={educationList}
                  errors={errors}
                  name={"edu"}
                />
              </Col>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="Job"
                  type={"text"}
                  label="شغل"
                  errors={errors}
                />
              </Col>
            </Row>{" "}
            <Row>
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="Email"
                  type={"text"}
                  label="ایمیل"
                  errors={errors}
                />
              </Col>

              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="PassWord"
                  type={"password"}
                  label="رمز عبور"
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6">
                <DropDownFormat
                  control={control}
                  label={"بانک"}
                  options={banksList}
                  errors={errors}
                  name={"idofbank"}
                />
              </Col>
              <Col className=" col-12 col-lg-6">
                <TelInput
                  control={control}
                  name="ACCno"
                  type={"tel"}
                  defaultValue={""}
                  label="شماره حساب"
                  errors={errors}
                />
              </Col>
            </Row>{" "}
            <Row>
              <Col className=" col-12 col-lg-6">
                <TelInput
                  control={control}
                  name="CartNo"
                  type={"tel"}
                  defaultValue={""}
                  label="شماره کارت"
                  errors={errors}
                />
              </Col>{" "}
              <Col className=" col-12 col-lg-6">
                <InputFormat
                  control={control}
                  name="Sheba"
                  type={"text"}
                  label="شبا"
                  errors={errors}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6">
                <DropDownFormat
                  control={control}
                  label={"استان"}
                  options={ProvinceList}
                  errors={errors}
                  name={"ProvinceId"}
                />
              </Col>
              <Col className=" col-12 col-lg-6">
                <DropDownFormat
                  control={control}
                  label={"شهر"}
                  options={cityList}
                  errors={errors}
                  name={"CityId"}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-12 col-lg-6">
                <TelInput
                  label="کد پستی"
                  type="text"
                  name="PostalCode"
                  control={control}
                  defaultValue={""}
                />
              </Col>
            </Row>
            <Row>
              <Col className=" col-9">
                <InputFormat
                  control={control}
                  name="Address"
                  type={"textarea"}
                  label="آدرس"
                  errors={errors}
                />
              </Col>
              <Col className=" col-3">
                <InputFormat
                  control={control}
                  name="no"
                  type={"text"}
                  label="پلاک"
                  errors={errors}
                />
                <InputFormat
                  control={control}
                  name="unit"
                  type={"text"}
                  label="واحد"
                  errors={errors}
                />
              </Col>
            </Row>
            <div className="col-12 d-flex justify-content-end  align-items-center">
              <Button type="submit">ذخیره</Button>
            </div>
          </Form>
        </div>
      )}
    </PanelContainer>
  );
};
